module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1700.d784afd9.svg";